document.addEventListener("DOMContentLoaded", async () => {
  breaksData.sort((a, b) => b.tier_value - a.tier_value);

  // Function to update cart UI without page reload
  const updateCartUI = async () => {
    // Fetch updated cart data
    const cart = await fetch("/cart.js").then((res) => res.json());

    // Update cart count in header/drawer if it exists
    const cartCountElements = document.querySelectorAll(
      ".cart-count, .cart-count-bubble, [data-cart-count]"
    );
    cartCountElements.forEach((el) => {
      if (el) el.textContent = cart.item_count;
    });

    // If your theme has a cart drawer, trigger its refresh function if available
    if (typeof window.refreshCart === "function") {
      window.refreshCart();
    } else if (typeof window.updateCartDrawer === "function") {
      window.updateCartDrawer();
    }

    // Dispatch a custom event other scripts might listen for
    document.dispatchEvent(
      new CustomEvent("cart:updated", { detail: { cart } })
    );
  };

  const check_cart = async () => {
    const rawHTML = await fetch("/").then((res) => res.text());
    const cart = await fetch("/cart.js").then((res) => res.json());
    const parser = new DOMParser();
    const htmlDoc = parser.parseFromString(rawHTML, "text/html");
    const items = JSON.parse(
      htmlDoc.querySelector("#items_in_the_cart")?.value
    );
    const cartAttributesArray = Object.keys(cart.attributes);
    const trimmedAttributes = cartAttributesArray
      .filter((attributeStr) =>
        breaksData.some((breakData) => breakData.attribute_key == attributeStr)
      )
      .map((cartAttribute) => ({
        key: cartAttribute,
        value: cart.attributes[cartAttribute],
      }));

    let attributesUpdated = false;

    if (!allowTiersAttributes) {
      if (trimmedAttributes.length) {
        const attributes = trimmedAttributes.map((cartAttribute) => ({
          key: cartAttribute.key,
          value: "",
        }));
        if (attributes.length) {
          const response = await update_cart_attributes(attributes);
          if (response) {
            attributesUpdated = true;
          }
        }
      }

      if (attributesUpdated) {
        await updateCartUI();
      }
      return;
    }

    let singleItems = 0;
    let bundleItems = 0;
    items?.forEach((item) => {
      if (!item.isExcluded) {
        if (item.isDouble) {
          bundleItems += item.quantity;
        } else {
          singleItems += item.quantity;
        }
      }
    });

    const wholeValues = singleItems + bundleItems * 2;
    const selectedBreak = breaksData.find((breakData) => {
      return wholeValues >= breakData.tier_value;
    });

    if (selectedBreak) {
      if (
        !trimmedAttributes.some(
          (cartAttribute) =>
            cartAttribute.key == selectedBreak.attribute_key &&
            cartAttribute.value == selectedBreak.attribute_value
        )
      ) {
        const response = await update_cart_attributes([
          {
            key: selectedBreak.attribute_key,
            value: selectedBreak.attribute_value,
          },
          ...trimmedAttributes.map((cartAttribute) => ({
            key: cartAttribute.key,
            value: "",
          })),
        ]);
        if (response) {
          attributesUpdated = true;
        }
      }
    } else {
      const attributes = trimmedAttributes.map((cartAttribute) => ({
        key: cartAttribute.key,
        value: "",
      }));
      if (attributes.length) {
        const response = await update_cart_attributes(attributes);
        if (response) {
          attributesUpdated = true;
        }
      }
    }

    // If attributes were updated, update the UI without reloading
    if (attributesUpdated) {
      await updateCartUI();
    }
  };

  const update_cart_attributes = async (attributes) => {
    if (!attributes) return false;
    const formData = new FormData();
    attributes.forEach((attribute) => {
      formData.append(`attributes[${attribute.key}]`, attribute.value);
    });
    try {
      const fetchResponse = await fetch("/cart/update.js", {
        method: "POST",
        body: formData,
        headers: {
          "X-Requested-With": "XMLHttpRequest",
        },
      }).then((res) => res.json());
      if (
        attributes.every(
          (attribute) =>
            fetchResponse.attributes[attribute.key] === attribute.value ||
            attribute.value === ""
        )
      ) {
        return true;
      }
      return false;
    } catch (err) {
      console.log("fetchResponse error", err);
      return false;
    }
  };

  const debounce = (func, delay) => {
    let timeoutId;
    return function (...args) {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => func.apply(this, args), delay);
    };
  };

  const listeners = () => {
    (function (ns, fetch) {
      ns.fetch = async (...args) => {
        const response = fetch.apply(this, args);
        response.then(async (res) => {
          if (res.url.includes("/cart") && !res.url.includes("/cart.js")) {
            const send = debounce(check_cart, 1000);
            send();
          }
        });
        return response;
      };
    })(window, window.fetch);
  };

  await check_cart();
  if (allowTiersAttributes) {
    listeners();
  }
});
